const origin = import.meta.env.VITE_ORIGIN ||
               ((location.hostname.includes("rcsworks.com") ||
			   location.hostname.includes("rcs-director-")) ? "ZETTACLOUD" : "SOUNDPLUS");


let region = "";
if (origin === "ZETTACLOUD") {
	if (location.hostname.includes("rcs-director-ap") || location.hostname.includes("virtual-studio.zetta.ap")) {
		region = "ap";
	}
	else if (location.hostname.includes("rcs-director-eu") || location.hostname.includes("virtual-studio.zetta.eu")) {
		region = "eu";
	}
	else if (location.hostname.includes("rcs-director-us") || location.hostname.includes("virtual-studio.zetta.us")) {
		region = "us";
	}
}

const brandEnvVars = Object.entries(import.meta.env)
						   .filter(([key]) => key.startsWith('VITE_'))
						   .reduce((acc, [key, value]) => {
							   const brand = key.split('_')[1];
							   const varName = key.split('_').slice(2).join('_');
							   if (!acc[brand]) {
								   acc[brand] = {};
							   }
							   acc[brand][varName] = value;
							   return acc;
						   }, {});

export default {
	ORIGIN: origin,
	ENV: import.meta.env.MODE,

	APP_VERSION: brandEnvVars["GLOBAL"].APP_VERSION,
	CSP_NONCE: brandEnvVars["GLOBAL"].CSP_NONCE,
	PORTAL_SERVICE_ID: brandEnvVars["GLOBAL"].PORTAL_SERVICE_ID,
	ZETTACLOUD_SERVICE_ID: brandEnvVars["GLOBAL"].ZETTACLOUD_SERVICE_ID,
	SOUND_PLUS_LIVE_CONSOLE_ACCESS_FEATURE_REF: brandEnvVars["GLOBAL"].SOUND_PLUS_LIVE_CONSOLE_ACCESS_FEATURE_REF,
	SCHEDULER_LICENSE_KEY: brandEnvVars["GLOBAL"].SCHEDULER_LICENSE_KEY,

	CSP: brandEnvVars[origin].CSP.replaceAll("{region}", region),
	PORTAL_URL: `https://${brandEnvVars[origin].PORTAL_URL}`.replace("{region}", region),
	PORTAL_PROXY_URL: `https://${brandEnvVars[origin].PORTAL_PROXY_URL}`.replace("{region}", region),
	SERVICE_MANAGEMENT_URL: `https://${brandEnvVars[origin].SERVICE_MANAGEMENT_URL}`.replace("{region}", region),
	SCHEDULER_URL: `https://${brandEnvVars[origin].SCHEDULER_URL}`.replace("{region}", region),
	SCHEDULE_BROADCASTER_URL: `https://${brandEnvVars[origin].SCHEDULE_BROADCASTER_URL}`.replace("{region}", region),
	CONSOLE_URL: brandEnvVars[origin].CONSOLE_URL.replace("{region}", region),
	SUPPORT_URL: brandEnvVars[origin].SUPPORT_URL.replace("{region}", region),
	ZETTA_URL: `https://${brandEnvVars[origin].ZETTA_URL}`.replace("{region}", region),
	UTIL_URL: `https://${brandEnvVars[origin].UTIL_URL}`.replace("{region}", region),
	MQTT_HOST: brandEnvVars[origin].MQTT_HOST.replace("{region}", region),
	ASTRUM_HTTP_HOST: brandEnvVars[origin].ASTRUM_HTTP_HOST.replace("{region}", region),
	AUTHORITY_BASE_URL: `https://${brandEnvVars[origin].AUTHORITY_BASE_URL}`,
	AUTHORITY_ORG_ID: brandEnvVars[origin].AUTHORITY_ORG_ID,
	AUTHORITY_CLIENT_ID: brandEnvVars[origin].AUTHORITY_CLIENT_ID,
	FS_ORG_ID: brandEnvVars[origin].FS_ORG_ID,
	PREFERENCES_URL:`https://${brandEnvVars[origin].PREFERENCES_URL.replace("{region}", region)}`
}